import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
function Rules() {
  return (
    <div className="container">
      <center>
        <img
          src="/rule.gif"
          alt="Rules need to be always followed!"
          className="img-fluid"
          width="400"
        />
        <h2>
          Just don't fake spam the button! Mostly you will get banned for doing
          that
        </h2>
        <hr />
        <Link to="/app">
          <button className="btn btn-primary">Let's go ahead</button>
        </Link>
        <br />
        <br />
      </center>
    </div>
  );
}
export default Rules;
